import React from "react";
import { Toaster } from "sonner";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";

export const Layout = ({ children }) => {
  return (
    <div className="grain min-h-screen bg-[#050505] text-neutral-100 selection:bg-[#e60000] selection:text-white">
      <ScrollToTop />
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid #262626",
            color: "#f5f5f5",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
};

export default Layout;
